import type { QuestFeRarity } from '@aegislab/shared';
import * as s from './RarityDot.css';

interface RarityDotProps {
  rarity: QuestFeRarity;
  /** Size in px. 미지정이면 등급별 기본값(8~12px)을 쓴다 — {@link RARITY_SIZE} */
  size?: number;
  className?: string;
}

/**
 * 등급별 기본 지름(px).
 *
 * 목록 행은 TIER 2 라 rarity 가 쓸 수 있는 표현이 **점 내부**로 제한된다
 * (`DESIGN.md` §Visual Hierarchy Rules — 행 배경·행 보더·모션 금지). 그래서
 * 크기·보더·glow 반경 셋이 목록에서 희소성을 지불하는 전부다.
 *
 * 개정 전에는 5등급이 전부 8px 였고 차등이 보더 알파 하나뿐이라, 실측 0.9% 인
 * LEGENDARY 가 7.1% 인 EPIC 과 알파 0.35 로 같고 두께만 1px↔2px 달랐다 — 8px
 * 원에서 지각되지 않는다. common·uncommon 을 8px 로 묶어 바닥을 만들고 위쪽만
 * 벌린 이유는 흔한 두 등급이 목록의 75.4% 라 여기가 배경이어야 나머지가 뜨기
 * 때문이다.
 */
const RARITY_SIZE: Record<QuestFeRarity, number> = {
  common: 8,
  uncommon: 8,
  rare: 9,
  epic: 10,
  legendary: 12,
};

export function RarityDot({ rarity, size, className }: RarityDotProps) {
  const diameter = size ?? RARITY_SIZE[rarity];

  return (
    <span
      className={`${s.base} ${s.rarityStyles[rarity]}${className ? ` ${className}` : ''}`}
      style={{ width: diameter, height: diameter }}
      aria-label={`등급 ${rarity.toUpperCase()}`}
      role="img"
    />
  );
}
